<template>
    <v-container class="pt-4 pb-12 py-sm-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Totem de Pagamento</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                {
                    text: 'Homepage',
                    disabled: false,
                    to: '/home',
                    exact: true,
                },
                {
                    text: 'Totem de pagamento',
                    disabled: true,
                    exact: true,
                },
            ]"></v-breadcrumbs>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-data-table :headers="visibleHeaders" :items="dataList.data" :server-items-length="dataList.count"
                    :disable-sort="true" :loading="dataList.loading" no-data-text="Nenhuma upbox foi encontrada"
                    loading-text="Carregando dados..." class="app-table hover-table payment-totem-table" hide-default-footer>

                    <template v-slot:[`item.name`]="{ item }">
                        {{ item.identificador }}
                    </template>

                    <template v-slot:[`item.version`]="{ item }">
                        {{ item.versao }}
                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                        <span :class="item.habilitado ? 'green--text' : 'error--text'">
                            <strong>{{ item.habilitado ? "Habilitado" : "Desabilitado" }}</strong>
                        </span>
                    </template>

                    <template v-slot:[`item.lastUpdated`]="{ item }">
                        {{ item.dataUltimaComunicacao | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                    </template>

   <template v-slot:[`item.actions`]="{ item }">
    <div class="d-flex align-center">
        <v-btn small color="primary-200" @click="viewItem(item)" class="mr-2 action-btn-fixed">
            <v-icon left>mdi-pencil-outline</v-icon>
            Editar
        </v-btn>
        <v-btn type="button" elevation="0" color="primary" dark
            @click="restartTotem(item.id)" small class="action-btn-fixed">Reiniciar</v-btn>
    </div>
</template>
                </v-data-table>
                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import totemStatus from "@/common/data/totem-status.data"

import { eventHub } from "@/main"

Vue.use(VueLodash)

export default {
    name: "PaymentTotemList",

    data: () => ({
        dataset: {
            totemStatus: totemStatus,
            data: {},
            operation: null
        },
        dataList: {
            filter: {
                name: "",
            },
            headers: [
                { text: "Identificador", value: "name", width: '220px' },
                { text: "Código Stone", value: "stoneCode", width: '150px', hideOnMedium: true },
                { text: "Versão", value: "version", width: '100px', hideOnMedium: true },
                { text: "Status", value: "status", width: '120px' },
                { text: "Última comunicação", value: "lastUpdated", width: '170px' },
                { text: 'Ações', value: 'actions', sortable: false, align: 'center', width: '170px' },
            ],
            data: [],
            loading: false,
            count: 0,

        },
    }),

    computed: {
        // Código Stone e Versão somem em telas menores (ex: notebooks 1024x768)
        // pra tabela não precisar de scroll horizontal.
        visibleHeaders() {
            const isMediumOrSmaller = this.$vuetify.breakpoint.width < 1264;
            return this.dataList.headers.filter((h) => !(isMediumOrSmaller && h.hideOnMedium));
        },
    },

    mounted() {

        this.getSelectedOperation();

        if (!this.dataset.operation) {
            this.$dialog.notify.error('Nenhuma operação selecionada!', { position: 'top-right', timeout: 5000 });
            return;
        }

        this.loadData();

        eventHub.$on('CHANGE-OPERATION', (value) => {
            this.getSelectedOperation();
            this.loadData()
        })
    },

    destroyed() {
        eventHub.$off('CHANGE-OPERATION')
    },

    methods: {
        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                default:
                    break;
            }
        },

        getSelectedOperation() {
            this.dataset.operation = localStorage.getItem('operation');
        },

        loadData() {
            this.load()
        },

        async load() {
            this.dataList.loading = true;

            try {
                const result = await axios.get('/api/totem-pagamento', {
                    params: { operacaoId: this.dataset.operation }
                });

                this.dataList.data = result.data;
                this.dataList.count = this.dataList.data.length;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        async restartTotem(id) {

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja reiniciar o totem?',
                title: 'Totem',
                actions: {
                    false: 'Cancelar',
                    true: 'Enviar'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true;

            try {
                await axios.post(`/api/totem-pagamento/${id}/restart`, {});

                this.$dialog.notify.info("Comando para reiniciar o totem foi enviado com sucesso!", { position: "top-right", timeout: 2000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataList.loading = false;
            }
        },

        viewItem(item) {
    this.$router.push(`totens/${item.id}`);
},

    },
};
</script>
<style scoped>

.action-btn-fixed {
  min-width: 0 !important;
  padding: 0 10px !important;
}

@media (max-width: 768px) {
  .v-data-table__mobile-row .v-btn {
    min-width: unset !important;
    padding: 0 6px !important;
    font-size: 10px !important;
    height: 22px !important;
  }
}

@media (max-width: 768px) {
.app-table.payment-totem-table.v-data-table--mobile ::v-deep .v-data-table__mobile-row {
  padding: 4px 0 !important;
  min-height: auto !important;
}
  .app-table.payment-totem-table.v-data-table--mobile ::v-deep tbody tr {
    border-bottom: 2px solid #000 !important;
    margin-bottom: 8px !important;
    padding-bottom: 4px !important;
    display: block !important;
  }

  .app-table.payment-totem-table.v-data-table--mobile ::v-deep .v-data-table__mobile-row {
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
  }
}
</style>